<template>
<div class="cfd-wrapper" ref="wrapper">
    <div class="cfd-table" ref="table">
        <div class="cfd-tbody">
            <InstrumentTableRow v-for="instrument in instrumentsToShow"
                :instrument="instrument"
                :key="instrument.Id"/>
        </div>
        <InstrumentTableHeader/>
    </div>
    <div class="cfd-scroller is-hidden" ref="scroller">
        <div class="cfd-scroller-content" ref="scroller-content"></div>
    </div>
</div>
</template>

<script>
import InstrumentTableHeader from './InstrumentTableHeader.vue';
import InstrumentTableRow from './InstrumentTableRow.vue';

export default {
    name: 'InstrumentTable',

    components: {
        InstrumentTableHeader,
        InstrumentTableRow
    },

    data () {
        return {
            // magic: https://stackoverflow.com/questions/9236314/how-do-i-synchronize-the-scroll-position-of-two-divs
            wrapperSync: false,
            scrollerSync: false
        }
    },

    computed: {
        instrumentsToShow () {
            return this.$store.state.instrumentsToShow;
        },

        columnsToShow () {
            return this.$store.state.columnsToShow;
        },

        requiredData () {
            return [this.instrumentsToShow, this.columnsToShow];
        },

        selectedGroup () {
            return this.$store.getters.selectedGroup;
        }
    },

    watch: {
        requiredData () {
            this.$nextTick(this.updateScroller);
        },

        selectedGroup () {
            const isDataLoadingWatcher = this.$watch(() => this.$store.state.isDataLoading, isDataLoading => {
                isDataLoadingWatcher();
                if (isDataLoading) {
                    return;
                }
                this.$refs.wrapper.scrollLeft = 0;
            });
        }
    },

    methods: {
        bindHandlers () {
            window.addEventListener('resize', this.updateScroller);
            window.addEventListener('scroll', this.updateScroller);
            this.$refs.wrapper.addEventListener('scroll', this.updateScroller);
            this.$refs.scroller.addEventListener('scroll', this.updateWrapper);
        },

        unbindHandlers () {
            window.removeEventListener('resize', this.updateScroller);
            window.removeEventListener('scroll', this.updateScroller);
            this.$refs.wrapper.removeEventListener('scroll', this.updateScroller);
            this.$refs.scroller.removeEventListener('scroll', this.updateWrapper);
        },

        updateScroller () {
            const wrapperRect = this.$refs.wrapper.getBoundingClientRect();
            const tableRect = this.$refs.table.getBoundingClientRect();
            const scroller = this.$refs.scroller;
            const isWrapperTooShort = wrapperRect.bottom < document.documentElement.clientHeight;
            const isTableTooShort = tableRect.width < wrapperRect.width;
            if (isWrapperTooShort || isTableTooShort) {
                scroller.classList.add('is-hidden');
                return;
            }
            scroller.classList.remove('is-hidden');
            const scrollerContent = this.$refs['scroller-content'];
            const left = `${parseInt(wrapperRect.left)}px`;
            const right = `${parseInt(document.documentElement.clientWidth - wrapperRect.right)}px`;
            const width = `${parseInt(tableRect.width)}px`;
            const scroll = this.$refs.wrapper.scrollLeft;
            scroller.style.right = right;
            scroller.style.left = left;
            scrollerContent.style.width = width;
            // magic: https://stackoverflow.com/questions/9236314/how-do-i-synchronize-the-scroll-position-of-two-divs
            if (!this.wrapperSync) {
                this.scrollerSync = true;
                scroller.scrollLeft = scroll;
            }
            this.wrapperSync = false;
        },

        updateWrapper () {
            const scroll = this.$refs.scroller.scrollLeft;
            // magic: https://stackoverflow.com/questions/9236314/how-do-i-synchronize-the-scroll-position-of-two-divs
            if (!this.scrollerSync) {
                this.wrapperSync = true;
                this.$refs.wrapper.scrollLeft = scroll;
            }
            this.scrollerSync = false;
        }
    },

    mounted () {
        this.updateScroller();
        this.bindHandlers();
    },

    beforeDestroy () {
        this.unbindHandlers();
    }
};
</script>

<style scoped>
.cfd-wrapper {
    overflow-x: auto;
}

.cfd-table {
    display: table;
    width: 100%;
}

.cfd-tbody {
    display: table-row-group;
}

.cfd-scroller {
    position:fixed;
    z-index: 10;
    overflow:auto;
    bottom:0;
}

.cfd-scroller.is-hidden {
    display: none;
}

.cfd-scroller-content {
    height: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/desktop/InstrumentTable.vue